import * as APITypes from "~/API";
import { getCommentList, removeComment } from "../../file-comment-bookmark";
import { S3ServiceLambda } from "~/services/s3";
import { removeServiceRequest } from "./removeServiceRequest";

/**
 * Removes a service request and all associated resources
 * (comments and uploaded files/images).
 */
export const removeAllServiceRequestData = async (
  payload: APITypes.DeleteServiceRequestInput
) => {
  try {
    const [comments] = await Promise.all([
      getCommentList({ parentID: payload.id }),
    ]);

    await Promise.all(
      comments.data.map((comment) =>
        removeComment({ id: comment.id, _version: comment._version })
      )
    );

    await S3ServiceLambda.removeAllForEntity({
      entityType: APITypes.EntityType.ServiceRequest,
      entityID: payload.id,
    });

    return removeServiceRequest(payload);
  } catch (error) {
    console.error("Failed to remove service request data", error);
    return {
      success: false,
      error,
    };
  }
};
